
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#798f8f","d":"m10.412 7.864 5.524-6.284h-1.309L9.83 7.036 6 1.58H1.58l5.794 8.25-5.794 6.59h1.31l5.065-5.762L12 16.42h4.419zm-1.793 2.04-.587-.822L3.36 2.544h2.01l3.77 5.276.587.822 4.9 6.858h-2.011z"}})])
          )
        }
      }
    